var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfileEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 23,
    cy: 23,
    r: 23,
    fill: "#8DC63F"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.0454 13.8657H13.4809C11.8086 13.8657 10.4541 15.3019 10.4541 17.071V33.0947C10.4541 34.8653 11.8086 36.3 13.4809 36.3H30.1281C31.8003 36.3 33.1548 34.8653 33.1548 33.0947V21.366L27.2314 27.6374C26.7142 28.1906 26.0405 28.5728 25.3004 28.7331L21.243 29.5927C18.5946 30.1527 16.2609 27.6813 16.7906 24.8785L17.6018 20.582C17.7486 19.8072 18.1088 19.0944 18.637 18.536L23.0454 13.8657Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.949 11.0538C35.796 10.6664 35.5716 10.3112 35.2876 10.0065C35.0083 9.70859 34.6717 9.47025 34.2979 9.30584C33.9296 9.14411 33.5317 9.06061 33.1295 9.06061C32.7273 9.06061 32.3295 9.14411 31.9612 9.30584C31.5874 9.47025 31.2507 9.70859 30.9714 10.0065L30.1451 10.8813L34.4613 15.4517L35.2876 14.5754C35.5746 14.2731 35.7993 13.9173 35.949 13.5282C36.2607 12.7328 36.2607 11.8491 35.949 11.0538ZM32.3229 17.7172L28.0052 13.1453L20.7758 20.803C20.6691 20.9166 20.5972 21.0584 20.5685 21.2116L19.7573 25.5096C19.6514 26.0696 20.119 26.5629 20.6472 26.4509L24.706 25.5928C24.8537 25.5599 24.9882 25.4835 25.092 25.3734L32.3229 17.7172Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileEdit);
export default __webpack_public_path__ + "static/media/profileEdit.930b083999fa5f92806be558b07ae66a.svg";
export { ForwardRef as ReactComponent };